import { useEffect } from "react";

import { VALID_WALLET_LINK_STATUSES } from "@swiggy-private/payment-core";
import { BOOLEAN_AS_STRING } from "@swiggy-private/payment-types";

import { AmazonPaySdkState, WalletData, WalletPaymentMethodData } from "@payment-ui/interfaces/Wallet";
import { PaymentGroupActions } from "@payment-ui/interfaces/Payment";

interface UseWalletOnLoadParams {
    methodData: WalletPaymentMethodData;
    onLoad: PaymentGroupActions<WalletPaymentMethodData>["onLoad"];
    enabled: boolean;
    isAmazonWallet: boolean;
    walletData: WalletData;
    amazonPaySdkStatus: AmazonPaySdkState | null;
    paymentAmount: string;
}

export const useWalletOnLoad = ({
    methodData,
    onLoad,
    enabled,
    isAmazonWallet,
    walletData,
    amazonPaySdkStatus,
    paymentAmount,
}: UseWalletOnLoadParams): void => {
    useEffect(() => {
        const isLinked =
            walletData.linkStatus === VALID_WALLET_LINK_STATUSES.LINKED ||
            (isAmazonWallet && amazonPaySdkStatus?.linked);

        const balance = isAmazonWallet ? amazonPaySdkStatus?.balance : walletData.balance;

        if (enabled) {
            onLoad?.({
                methodName: methodData?.name,
                orderAmount: Number(paymentAmount),
                methodSpecificData: {
                    walletBalance: balance ? `${balance}` : "0",
                    linked: isLinked ? BOOLEAN_AS_STRING.TRUE : BOOLEAN_AS_STRING.FALSE,
                },
            });
        }
    }, [
        isAmazonWallet,
        amazonPaySdkStatus?.balance,
        amazonPaySdkStatus?.linked,
        enabled,
        onLoad,
        paymentAmount,
        methodData?.name,
        walletData.balance,
        walletData.linkStatus,
    ]);
};
